import { Link } from "gatsby";
import React from "react";
import Nav from "react-bootstrap/Nav";
import styled from "styled-components";
import { ProductCategory } from "../../shared/use-product-categories";

const StyledNav = styled(Nav)`
  margin: 10px 0;
`;

const StyledNavItem = styled(Nav.Item)`
  margin: 15px 15px 15px 0;
  display: inline-block;
  line-height: 20px;
  border-radius: 4px;
  text-transform: uppercase;
  font-weight: 400;
  transition: all 0.3s ease-in-out;
`;

const StyledNavLink = styled(Nav.Link)`
  background: #fff;
  color: #666666;
  padding: 10px 20px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);

  &:hover,
  &.active {
    background: #13a456;
    color: #fff;
  }
`;

interface ProductCategoriesNavProps {
  basePath: string;
  categories: ProductCategory[];
}

export const ProductCategoriesNav: React.FC<ProductCategoriesNavProps> = props => (
  <StyledNav>
    {props.categories.map(c => (
      <StyledNavItem key={c.slug!}>
        <StyledNavLink
          as={Link}
          to={`/${props.basePath}/${c.slug}`}
          activeClassName="active"
        >
          {c.title}
        </StyledNavLink>
      </StyledNavItem>
    ))}
  </StyledNav>
);
